import React from 'react';

import PetWalker from '../components/single-order/admin/PetWalker';
import ClientInfo from '../components/single-order/admin/ClientInfo';

const SingleOrder = () => {


    return (
        <div className="min-h-screen p-8">
            {/* Tabs Section */}
            <div className="flex justify-between items-center mb-6">
                {/* Heading Section */}
                <h1 className="text-[#3E358F] text-3xl font-bold">Orders Detail</h1>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 ">
                <div className="col-span-3">
                    <PetWalker />
                </div>

                <div class="grid grid-rows-4 grid-flow-col gap-4">
                    <ClientInfo />
                </div>
            </div>


        </div>
    );
};

export default SingleOrder;
